var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DModeling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_59958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7182 175C99.0008 174.525 98.2963 174.011 97.5533 173.575C90.8919 169.71 84.2176 165.858 77.5434 161.994C77.0822 161.724 76.6467 161.429 76.1086 161.095C77.5818 158.54 79.0038 156.062 80.4898 153.494C84.7172 155.934 88.8422 158.322 92.9671 160.71C94.9912 161.878 97.0408 163.021 99.0393 164.241C99.7567 164.677 100.282 164.677 101.012 164.241C106.687 160.915 112.401 157.628 118.101 154.342C118.562 154.072 119.023 153.828 119.574 153.52C121.035 156.062 122.47 158.54 123.956 161.133C121.201 162.738 118.562 164.279 115.911 165.807C111.055 168.619 106.2 171.418 101.345 174.229C100.974 174.448 100.653 174.73 100.307 174.987H99.7182V175Z",
    fill: "url(#paint0_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.407 151.967V150.272C104.407 134.814 104.407 119.355 104.381 103.897C104.381 102.78 104.689 102.177 105.675 101.599C119.036 93.921 132.372 86.179 145.72 78.4626C146.169 78.2058 146.617 77.9619 147.245 77.6152C147.283 78.3214 147.334 78.7964 147.334 79.2715C147.334 94.7812 147.334 110.291 147.347 125.788C147.347 126.674 147.232 127.303 146.335 127.816C132.641 135.7 118.959 143.621 105.278 151.53C105.073 151.646 104.855 151.736 104.407 151.954V151.967Z",
    fill: "url(#paint1_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5548 152.005C90.3922 149.027 85.4602 146.163 80.5282 143.313C71.6634 138.19 62.7986 133.055 53.9209 127.945C53.0883 127.47 52.6655 126.982 52.6655 125.916C52.704 110.316 52.6911 94.704 52.704 79.1044C52.704 78.6807 52.768 78.2699 52.8064 77.6279C55.2532 79.0402 57.5207 80.337 59.7881 81.6466C71.3559 88.3358 82.9237 95.0378 94.5043 101.714C95.2345 102.138 95.6444 102.549 95.6444 103.512C95.606 119.317 95.6188 135.109 95.6188 150.914C95.6188 151.196 95.5932 151.492 95.5676 152.018L95.5548 152.005Z",
    fill: "url(#paint2_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.851 69.9374C140.635 71.2213 138.585 72.4154 136.522 73.6094C124.827 80.3756 113.118 87.1291 101.448 93.9466C100.372 94.5758 99.6029 94.5244 98.5524 93.921C85.2681 86.1918 71.958 78.5011 58.6608 70.7976C58.2381 70.5537 57.8282 70.2969 57.2261 69.9502C57.6616 69.6549 57.9819 69.411 58.3278 69.2056C71.8427 61.3865 85.3577 53.5675 98.8599 45.7356C99.5773 45.3247 100.128 45.0936 100.986 45.5815C114.732 53.5803 128.503 61.5406 142.262 69.5137C142.39 69.5907 142.492 69.6806 142.851 69.9374Z",
    fill: "url(#paint3_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4512 46.1204C78.9908 43.5783 77.5561 41.1003 76.0701 38.5196C78.1966 37.2871 80.2078 36.1059 82.2319 34.9375C87.8044 31.7149 93.3769 28.4666 98.9751 25.2825C99.4619 25.0128 100.333 24.8716 100.769 25.1284C108.365 29.4423 115.91 33.8333 123.469 38.2115C123.584 38.2757 123.674 38.4041 123.891 38.5967C122.469 41.0618 121.047 43.5398 119.561 46.1204C116.666 44.4513 113.848 42.8208 111.03 41.1902C107.737 39.29 104.419 37.4155 101.153 35.4511C100.333 34.9632 99.7437 34.9504 98.911 35.4511C93.236 38.7893 87.5226 42.0761 81.8091 45.3629C81.3992 45.6069 80.9636 45.8251 80.464 46.1076L80.4512 46.1204Z",
    fill: "url(#paint4_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.872 89.8504H156.174C156.174 89.2213 156.174 88.6435 156.174 88.0786C156.174 81.6205 156.148 75.1752 156.199 68.7171C156.199 67.7028 155.892 67.1379 155.008 66.65C149.333 63.4145 143.683 60.1277 138.034 56.8537C137.573 56.5841 137.137 56.3145 136.638 56.0063C138.124 53.4257 139.558 50.9477 141.032 48.3799C146.335 51.4484 151.511 54.4528 156.699 57.4443C159.146 58.8566 161.618 60.2433 164.026 61.7198C164.475 61.9894 164.949 62.6442 164.949 63.1321C165 71.837 164.987 80.542 164.974 89.2341C164.974 89.3753 164.923 89.5166 164.859 89.8376L164.872 89.8504Z",
    fill: "url(#paint5_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.174 109.815H164.91C164.936 110.278 165 110.701 165 111.125C165 119.483 165 127.842 165.013 136.2C165.013 136.996 164.846 137.522 164.078 137.972C156.596 142.26 149.128 146.6 141.659 150.914C141.493 151.003 141.313 151.081 141.006 151.222C139.558 148.718 138.124 146.24 136.638 143.659C137.073 143.39 137.483 143.146 137.893 142.902C143.543 139.628 149.179 136.328 154.867 133.106C155.84 132.554 156.212 131.963 156.212 130.82C156.148 123.887 156.186 116.941 156.186 109.828L156.174 109.815Z",
    fill: "url(#paint6_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8392 89.8502H35.0256C35.0256 89.311 35.0256 88.8488 35.0256 88.3737C35.0256 80.1181 35.0256 71.8497 35.0256 63.5941C35.0256 62.8494 35.0256 62.2332 35.8455 61.771C43.4165 57.4442 50.9618 53.0532 58.5199 48.7007C58.6352 48.6365 58.7761 48.598 59.0451 48.4824C60.4799 50.9604 61.9019 53.4383 63.4007 56.0319C62.8626 56.3528 62.3758 56.661 61.8762 56.9563C56.2653 60.2046 50.6671 63.4657 45.0306 66.6755C44.1595 67.1762 43.8264 67.7155 43.8264 68.7426C43.8776 75.1494 43.852 81.5433 43.852 87.95C43.852 88.5278 43.852 89.1184 43.852 89.8759L43.8392 89.8502Z",
    fill: "url(#paint7_linear_121_59958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1281 109.828H43.8392C43.8392 110.406 43.8392 110.971 43.8392 111.536C43.8392 117.942 43.8776 124.349 43.8136 130.743C43.8136 131.95 44.2235 132.553 45.2355 133.118C50.8337 136.29 56.3934 139.538 61.9531 142.761C62.4143 143.03 62.8498 143.313 63.3879 143.646C61.9275 146.189 60.4927 148.667 59.0195 151.234C57.9178 150.605 56.9186 150.04 55.9194 149.463C49.3348 145.649 42.7631 141.836 36.1657 138.049C35.4868 137.676 35 137.355 35 136.418C35.0384 127.867 35.0256 119.303 35.0256 110.753C35.0256 110.47 35.0769 110.188 35.1153 109.828H35.1281Z",
    fill: "url(#paint8_linear_121_59958)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_59958",
    x1: 100.032,
    y1: 153.494,
    x2: 100.032,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_59958",
    x1: 125.864,
    y1: 77.6152,
    x2: 125.864,
    y2: 151.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_59958",
    x1: 74.155,
    y1: 77.6279,
    x2: 74.155,
    y2: 152.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_59958",
    x1: 100.038,
    y1: 45.3066,
    x2: 100.038,
    y2: 94.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_59958",
    x1: 99.9807,
    y1: 24.9932,
    x2: 99.9807,
    y2: 46.1204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_59958",
    x1: 150.812,
    y1: 48.3799,
    x2: 150.812,
    y2: 89.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_59958",
    x1: 150.825,
    y1: 109.815,
    x2: 150.825,
    y2: 151.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_59958",
    x1: 49.2132,
    y1: 48.4824,
    x2: 49.2132,
    y2: 89.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_59958",
    x1: 49.1939,
    y1: 109.828,
    x2: 49.1939,
    y2: 151.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_59958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 150,
    fill: "white",
    transform: "translate(35 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DModeling);
export default __webpack_public_path__ + "static/media/3D_Modeling.d1d01e16dfb24edaba8984fe269f92c1.svg";
export { ForwardRef as ReactComponent };